import React, { type ReactElement, type ReactNode } from "react";

export enum MarkdownTokenEvidenceLevel {
  Block = "block",
  Inline = "inline",
}

export enum MarkdownTokenEvidenceState {
  Control = "control",
  Dropped = "dropped",
  NonSemantic = "non-semantic",
  Rendered = "rendered",
}

interface MarkdownTokenEvidenceProps {
  readonly children: ReactNode;
  readonly enabled: boolean;
  readonly level: MarkdownTokenEvidenceLevel;
  readonly source: string;
  readonly state: MarkdownTokenEvidenceState;
  readonly tokenType: string;
}

export function MarkdownTokenEvidence({
  children,
  enabled,
  level,
  source,
  state,
  tokenType,
}: MarkdownTokenEvidenceProps): ReactElement {
  if (!enabled) return <>{children}</>;

  const evidence = {
    "data-evidence-level": level,
    "data-render-state": state,
    "data-source-raw": source,
    "data-token-type": tokenType,
    style: { display: "contents" },
  } as const;

  return level === MarkdownTokenEvidenceLevel.Inline ? (
    <span {...evidence}>{children}</span>
  ) : (
    <div {...evidence}>{children}</div>
  );
}
